import React, { useEffect, useState } from "react";
import { ApiCall, show_error } from "../../helper/Helper";

const Privacypolicy = () => {
  const [data, setdata] = useState({});

  const fetchData = async () => {
    try {
      const header = { "Content-Type": "application/json" };
      const subUri = "/apps_privacy";
      const body = {};
      const method = "get";
      const res = await ApiCall(header, subUri, body, method);
      const privacyData = res?.data?.privacy?.[0].description;
      setdata(privacyData);
    } catch (error) {
      console.log(show_error(error));
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page when the component is loaded
    fetchData();
  }, []);

  const bufferData = data?.data;
  const decodedString = new TextDecoder().decode(new Uint8Array(bufferData));

  return (
    <>
      <div className="w-full">
        <div className=" md:w-[70%] w-full mx-auto px-10 py-5 flex flex-col gap-4">
          <div
            className="text-lg bg-[#F6F7F9] px-6 py-8 rounded-lg shadow-sm privacy-content"
            dangerouslySetInnerHTML={{ __html: decodedString }}
          />
        </div>
      </div>
    </>
  );
};

export default Privacypolicy;
